import React, { useState } from 'react'

function BotellaSVG({ fillPercentage }) {
	// Aseguramos que el porcentaje esté en [0, 100].
	const clampedFill = Math.max(0, Math.min(fillPercentage, 100));
	
	// Altura total interna de la botella (ejemplo aproximado).
	const maxFillHeight = 120; 
	// Calculamos la altura del “agua” a partir del porcentaje.
	const fillHeight = (clampedFill / 100) * maxFillHeight;
  
	return (
		<svg width="120" height="140" viewBox="0 0 100 133">
		<defs>
			
			<clipPath id="bottleClip">
			<path 
				  d="
				  M20,113.3
				  A10,6.7 0 0 0 30,120
				  L70,120
				  A10,6.7 0 0 0 80,113.3
				  L80,13.3
				  L65,3.3
				  L35,3.3
				  L20,13.3
				  Z
				"
			  
			/>
			</clipPath>
		</defs>

		<path
			  d="
			  M20,113.3
			  A10,6.7 0 0 0 30,120
			  L70,120
			  A10,6.7 0 0 0 80,113.3
			  L80,13.3
			  L65,3.3
			  L35,3.3
			  L20,13.3
			  Z
			"
		  
			fill="none"
			stroke="#555"
			strokeWidth="3"			
			// stroke-width="3"
		/>

		<rect
			x="20"
			y={120 - fillHeight}
			width="100"
			height={fillHeight}
			fill="#5BB033"
			clipPath='url(#bottleClip)'
			// clip-path="url(#bottleClip)"
		/>
	</svg>
	);
}

// function MyIcon ({fillPercentage}) {
// 	// Aseguramos que el porcentaje esté en [0, 100].
// 	const clampedFill = Math.max(0, Math.min(fillPercentage, 100));
	
// 	// Altura total interna de la botella (ejemplo aproximado).
// 	const maxFillHeight = 160; 
// 	// Calculamos la altura del “agua” a partir del porcentaje.
// 	const fillHeight = (clampedFill / 100) * maxFillHeight;
// 	return (
// 		<svg width="200" height="300" viewBox="0 0 200 300">
// 			<defs>
// 			{/* 
// 				Definimos la forma de la botella en un clipPath. 
// 				Ajusta el path a la forma que desees 
// 				(aquí es un ejemplo sencillo con curvas “Q”). 
// 			*/}
// 			<clipPath id="bottleClip2">
// 				<g id="SVGRepo_iconCarrier"> <path d="M332.5,144.468c0-1.8-0.739-42.763-62-56.237V70.899c10.093-1.007,18-9.545,18-19.899V20c0-11.028-8.972-20-20-20h-83 c-11.028,0-20,8.972-20,20v31c0,10.006,7.394,18.295,17,19.75v17.305c-58.888,12.282-62,48.904-62,56.413v28.152 c0,8.7,3.705,16.727,9.61,22.615c-5.905,5.568-9.61,13.16-9.61,21.387v40.559c0,7.928,3.397,15.269,8.869,20.797 c-5.472,5.505-8.869,12.813-8.869,20.706v40.56c0,8.15,3.606,15.676,9.37,21.246c-5.764,5.558-9.37,13.068-9.37,21.2v40.56 c0,16.669,15.066,30.751,32.9,30.751h148c17.439,0,31.1-13.508,31.1-30.751v-40.56c0-8.143-3.306-15.549-8.681-21.049 c5.399-5.497,8.681-13.001,8.681-21.397v-40.56c0-8.06-3.022-15.302-8.042-20.724c5.02-5.442,8.042-12.701,8.042-20.779v-40.559 c0-8.465-3.369-16.021-8.898-21.512c5.502-5.83,8.898-13.759,8.898-22.49V144.468z M185.5,20h83l0.002,31H185.5V20z M312.5,422.249 c0,6.229-4.668,10.751-11.1,10.751h-148c-6.872,0-12.9-5.023-12.9-10.751v-40.56c0-5.694,6.028-10.689,12.9-10.689h102.1 c5.522,0,10-4.478,10-10c0-0.169-0.017-0.333-0.025-0.5c0.008-0.167,0.025-0.331,0.025-0.5c0-5.522-4.478-10-10-10H153.4 c-6.872,0-12.9-5.026-12.9-10.757v-40.56c0-5.691,6.028-10.684,12.9-10.684h96.1h2c5.522,0,10-4.478,10-10s-4.478-10-10-10h-2h-96.1 c-6.752,0-12.9-5.157-12.9-10.819v-40.559c0-5.658,6.028-10.622,12.9-10.622h93.1c5.522,0,10-4.478,10-10 c0-0.169-0.017-0.333-0.025-0.5c0.008-0.167,0.025-0.331,0.025-0.5c0-5.522-4.478-10-10-10h-93.1c-6.752,0-12.9-5.9-12.9-12.38 v-28.152c0-4.991,2.58-30.289,53.516-38.184c5.32-0.824,8.994-5.702,8.393-11.002c0.054-0.421,0.091-0.846,0.091-1.282V71h48v25 c0,4.036,2.396,7.505,5.839,9.084c1.108,0.724,2.375,1.24,3.762,1.48c51.699,8.928,52.398,37.615,52.399,37.903v28.152 c0,6.826-5.203,12.38-11.6,12.38c-5.522,0-10,4.478-10,10c0,0.456,0.041,0.901,0.1,1.341c0.181,5.364,4.575,9.659,9.983,9.659 c6.565,0,11.517,4.566,11.517,10.622v40.559c0,6.067-5.04,10.819-11.475,10.819c-5.522,0-10,4.478-10,10s4.478,10,10,10 c0.028,0,0.056-0.002,0.085-0.002c0.014,0,0.027,0.002,0.04,0.002c6.471,0,11.35,4.593,11.35,10.684v40.56 c0,6.032-5.04,10.757-11.475,10.757c-4.732,0-8.687,3.291-9.725,7.706c-0.361,1.033-0.567,2.138-0.567,3.294c0,5.522,4.478,10,10,10 c6.598,0,11.767,4.695,11.767,10.689V422.249z"></path> </g>

// 			</clipPath>
// 			</defs>

// 			<g id="SVGRepo_iconCarrier"> <path d="M332.5,144.468c0-1.8-0.739-42.763-62-56.237V70.899c10.093-1.007,18-9.545,18-19.899V20c0-11.028-8.972-20-20-20h-83 c-11.028,0-20,8.972-20,20v31c0,10.006,7.394,18.295,17,19.75v17.305c-58.888,12.282-62,48.904-62,56.413v28.152 c0,8.7,3.705,16.727,9.61,22.615c-5.905,5.568-9.61,13.16-9.61,21.387v40.559c0,7.928,3.397,15.269,8.869,20.797 c-5.472,5.505-8.869,12.813-8.869,20.706v40.56c0,8.15,3.606,15.676,9.37,21.246c-5.764,5.558-9.37,13.068-9.37,21.2v40.56 c0,16.669,15.066,30.751,32.9,30.751h148c17.439,0,31.1-13.508,31.1-30.751v-40.56c0-8.143-3.306-15.549-8.681-21.049 c5.399-5.497,8.681-13.001,8.681-21.397v-40.56c0-8.06-3.022-15.302-8.042-20.724c5.02-5.442,8.042-12.701,8.042-20.779v-40.559 c0-8.465-3.369-16.021-8.898-21.512c5.502-5.83,8.898-13.759,8.898-22.49V144.468z M185.5,20h83l0.002,31H185.5V20z M312.5,422.249 c0,6.229-4.668,10.751-11.1,10.751h-148c-6.872,0-12.9-5.023-12.9-10.751v-40.56c0-5.694,6.028-10.689,12.9-10.689h102.1 c5.522,0,10-4.478,10-10c0-0.169-0.017-0.333-0.025-0.5c0.008-0.167,0.025-0.331,0.025-0.5c0-5.522-4.478-10-10-10H153.4 c-6.872,0-12.9-5.026-12.9-10.757v-40.56c0-5.691,6.028-10.684,12.9-10.684h96.1h2c5.522,0,10-4.478,10-10s-4.478-10-10-10h-2h-96.1 c-6.752,0-12.9-5.157-12.9-10.819v-40.559c0-5.658,6.028-10.622,12.9-10.622h93.1c5.522,0,10-4.478,10-10 c0-0.169-0.017-0.333-0.025-0.5c0.008-0.167,0.025-0.331,0.025-0.5c0-5.522-4.478-10-10-10h-93.1c-6.752,0-12.9-5.9-12.9-12.38 v-28.152c0-4.991,2.58-30.289,53.516-38.184c5.32-0.824,8.994-5.702,8.393-11.002c0.054-0.421,0.091-0.846,0.091-1.282V71h48v25 c0,4.036,2.396,7.505,5.839,9.084c1.108,0.724,2.375,1.24,3.762,1.48c51.699,8.928,52.398,37.615,52.399,37.903v28.152 c0,6.826-5.203,12.38-11.6,12.38c-5.522,0-10,4.478-10,10c0,0.456,0.041,0.901,0.1,1.341c0.181,5.364,4.575,9.659,9.983,9.659 c6.565,0,11.517,4.566,11.517,10.622v40.559c0,6.067-5.04,10.819-11.475,10.819c-5.522,0-10,4.478-10,10s4.478,10,10,10 c0.028,0,0.056-0.002,0.085-0.002c0.014,0,0.027,0.002,0.04,0.002c6.471,0,11.35,4.593,11.35,10.684v40.56 c0,6.032-5.04,10.757-11.475,10.757c-4.732,0-8.687,3.291-9.725,7.706c-0.361,1.033-0.567,2.138-0.567,3.294c0,5.522,4.478,10,10,10 c6.598,0,11.767,4.695,11.767,10.689V422.249z"></path> </g>

			
// 			{/* 
// 		  Este rectángulo representa el agua. 
// 		  Se "recorta" con el clipPath para tomar la forma de la botella.
// 			*/}
// 			<rect
// 			x="20"
// 			/* La parte superior depende de cuánto llenado queramos */
// 			y={180 - fillHeight}
// 			width="60"
// 			height={fillHeight}
// 			fill=" #5BB033"
// 			clipPath="url(#bottleClip2)"
// 			/>
// 		</svg>
// 	)
// }

 
  

export const ContainerFilling = ({percentageValue}) => {
	const [porcentaje, setPorcentaje] = useState(50);
	const [isValidValue, setIsValidValue] = useState(true)

	function parseValue(inputString) {
		// Elimina espacios al inicio y al final
		const trimmed = inputString.trim();
	  
		// Verifica si el último carácter es '%'
		if (trimmed.endsWith('%')) {
		  // Retira el símbolo '%' y convierte el resto a número
		  const numericPart = trimmed.slice(0, -1);
		  return parseFloat(numericPart);
		} else {
		  // En caso de que no sea porcentaje, simplemente conviértelo a número
		//   return parseFloat(trimmed);
			// setIsValidValue(false)
			// console.log("No es porcentaje:",inputString)
			return 0;
		}
	}

  return (
	<div style={{ textAlign: "center", marginTop: "2rem" }}>

    	<BotellaSVG fillPercentage={parseValue(percentageValue[0])} />
		<div
			style={{
			position: "absolute",
			top: "60%",
			left: "51%",
			transform: "translate(-60%, -50%)",
			fontSize: "16px",
			fontWeight: "bold",
			}}
		>
			{percentageValue[0]}
		</div>
    </div>
  )
}
